export const mediaPatterns = {
  imgur: /\b(http|https)?:\/\/(i\.)?imgur\.com\/\S+/gi,
  meee: /\b(http|https)?:\/\/(i\.)?meee\.com\.tw\/\S+/gi,
  twimg: /\b(http|https)?:\/\/pbs\.twimg\.com\/media\/\S+/gi,
  sinaimg: /\b(http|https)?:\/\/[a-z0-9]{2,3}\.sinaimg\.cn\/\S+[a-z0-9]{34}\.(jpg|png|gif)/gi,
  youtube: /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/gi,
  imgpoi: /\b(http|https)?:\/\/imgpoi\.com\/i\/\S+\.(jpg|png|gif)/gi,
  urusai: /\b(http|https)?:\/\/i\.urusai\.cc\/\S+\.(jpg|png|gif)/gi
};

export const getThumbnailUrl = (link) => {
  if (link.includes('youtube.com') || link.includes('youtu.be')) {
    const match = link.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (match && match[1]) {
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    }
  }
  
  if (link.includes('://imgur.com/')) {
    return link.replace(/:\/\/imgur\.com/, '://i.imgur.com') + '.jpg';
  } else if (link.includes('twimg.com') && !link.includes('?format=')) {
    return `${link}?format=jpg&name=large`;
  }
  
  return link;
};